import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-offers',
    templateUrl: './offers.component.html',
    styleUrls: ['./offers.component.scss'],
    standalone: false
})
export class OffersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
